function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
var CHARACTERS = 'abcdefghijklmnopqrstuvwxyz';
export function character() {
  return CHARACTERS.charAt(Math.floor(Math.random() * CHARACTERS.length));
}
export function word() {
  var length = Math.floor(Math.random() * 12) + 1;
  var result = '';
  for (var i = 0; i < length; i++) {
    result += character();
  }
  return result.length === 1 ? result.toUpperCase() : result;
}
export function sentence() {
  var length = Math.floor(Math.random() * 12) + 2;
  var result = [];
  for (var i = 0; i < length; i++) {
    result.push(word());
  }
  result[0] = result[0].charAt(0).toUpperCase() + result[0].slice(1);
  return result.join(' ') + '.';
}
export function Paragraph() {
  var length = Math.floor(Math.random() * 10) + 5;
  var result = [];
  for (var i = 0; i < length; i++) {
    result.push(sentence());
  }
  return /*#__PURE__*/React.createElement("p", {
    className: "paragraph",
    style: {
      display: 'block',
      flex: '1 1 300px',
      textAlign: 'justify',
      margin: 0
    }
  }, result.join(' '));
}
export default function Paragraphs(_ref) {
  var count = _ref.count;
  return _toConsumableArray(Array(count)).map(function () {
    return /*#__PURE__*/React.createElement(Paragraph, null);
  });
}
export function PrintColumns(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "column",
    style: {
      gap: '2em',
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, children);
}